import React, {

  useEffect,

  useMemo,

  useState,

} from "react";

import AdminSidebar from "./AdminSidebar";

import AdminTopbar from "./Admintopbar";

import { djangoApi } from "../api/auth";

import {

  PROCTOR_RETENTION_MS,

  getStudents,

  getProctorSessions,

  sendProctorWarning,

  forceSubmitProctoringAttempt,

} from "../api/adminclient";

const ROSTER_POLL_MS = 10000;

const RETENTION_DAYS = Math.round(

  PROCTOR_RETENTION_MS /

    (24 * 60 * 60 * 1000)

);

/*

 * Backend event types.

 *

 * The detector may also produce some event names

 * that are not in this list, so unknown values are

 * displayed safely.

 */

const EVENT_LABELS = {

  PERSON_ABSENT: "Person absent",

  PHONE_DETECTED: "Phone detected",

  BOOK_DETECTED: "Book / notes detected",

  MULTIPLE_PERSON: "Multiple people detected",

  TAB_SWITCH: "Tab switch",

  FULLSCREEN_EXIT: "Fullscreen exit",

  COPY_ATTEMPT: "Copy attempt",

  CAMERA_ERROR: "Camera error",

  CAMERA_STARTED: "Camera started",

  OTHER: "Other",

  // Detector event values currently used by

  // the detection service.

  NO_FACE: "No face detected",

  OBJECT_DETECTED: "Object detected",

  MULTIPLE_FACES: "Multiple people detected",

  // Older / alternate values kept for safe display.

  no_face: "No face detected",

  no_face_auto_submit: "Auto-submitted: no face",

  multiple_persons: "Multiple people detected",

  multiple_persons_auto_submit:

    "Auto-submitted: multiple people",

  phone_detected: "Phone detected",

  phone_detected_auto_submit:

    "Auto-submitted: phone",

  book_detected: "Book / notes detected",

  book_detected_auto_submit:

    "Auto-submitted: book / notes",

};

function eventLabel(type) {

  if (!type) {

    return "Unknown event";

  }

  return (

    EVENT_LABELS[type] ||

    String(type)

      .replaceAll("_", " ")

      .replace(/\b\w/g, (c) => c.toUpperCase())

  );

}

/*

 * Normalize event severity.

 *

 * Backend values:

 * INFO

 * WARNING

 * CRITICAL

 */

function normalizeSeverity(severity) {

  return String(severity || "INFO")

    .trim()

    .toUpperCase();

}

function severityLabel(severity) {

  const value = normalizeSeverity(severity);

  if (value === "CRITICAL") {

    return "Critical";

  }

  if (value === "WARNING") {

    return "Warning";

  }

  return "Info";

}

/*

 * Small helper used for the visual severity styles.

 */

function severityStyles(severity) {

  const value = normalizeSeverity(severity);

  if (value === "CRITICAL") {

    return {

      backgroundColor: "#fee2e2",

      color: "#b91c1c",

      borderColor: "#fecaca",

    };

  }

  if (value === "WARNING") {

    return {

      backgroundColor: "#fef3c7",

      color: "#92400e",

      borderColor: "#fde68a",

    };

  }

  return {

    backgroundColor: "#e0f2fe",

    color: "#0369a1",

    borderColor: "#bae6fd",

  };

}

/*

 * Event row background based on severity.

 */

function eventRowStyles(severity) {

  const value = normalizeSeverity(severity);

  if (value === "CRITICAL") {

    return {

      backgroundColor: "#fff7f7",

      border: "1px solid #fecaca",

      borderRadius: "10px",

      padding: "0.75rem",

      marginBottom: "0.6rem",

    };

  }

  if (value === "WARNING") {

    return {

      backgroundColor: "#fffbeb",

      border: "1px solid #fde68a",

      borderRadius: "10px",

      padding: "0.75rem",

      marginBottom: "0.6rem",

    };

  }

  return {

    backgroundColor: "#f8fafc",

    border: "1px solid #e5e7eb",

    borderRadius: "10px",

    padding: "0.75rem",

    marginBottom: "0.6rem",

  };

}

function timeAgo(iso) {

  if (!iso) {

    return "—";

  }

  const timestamp = new Date(iso).getTime();

  if (Number.isNaN(timestamp)) {

    return "—";

  }

  const diffMs = Date.now() - timestamp;

  if (diffMs < 0) {

    return "just now";

  }

  const mins = Math.floor(

    diffMs / 60000

  );

  if (mins < 1) {

    return "just now";

  }

  if (mins < 60) {

    return `${mins}m ago`;

  }

  const hours = Math.floor(mins / 60);

  if (hours < 24) {

    return `${hours}h ago`;

  }

  return `${Math.floor(hours / 24)}d ago`;

}
function getRecordedVideoPlaybackUrl(video, session) {
  if (!video) return "";

  if (video.playback_url) return video.playback_url;
  if (video.playbackUrl) return video.playbackUrl;

  const videoId = video.id;

  const beginnerAttemptId =
    video.beginner_attempt_id ??
    video.beginner_attempt?.id ??
    session?.beginner_attempt_id ??
    session?.beginner_attempt?.id;

  const standardAttemptId =
    video.attempt_id ??
    video.attempt?.id ??
    session?.attempt_id ??
    session?.attempt?.id;

  if (beginnerAttemptId && videoId) {
    return `/api/proctoring/beginner-attempts/${beginnerAttemptId}/video/${videoId}/play/`;
  }

  if (standardAttemptId && videoId) {
    return `/api/proctoring/attempts/${standardAttemptId}/video/${videoId}/play/`;
  }

  return video.video_url || video.video || "";
}
function AuthenticatedVideo({ src, style }) {

  const [objectUrl, setObjectUrl] = useState("");

  const [videoError, setVideoError] = useState("");

  useEffect(() => {

    let active = true;

    let localUrl = "";

    setObjectUrl("");

    setVideoError("");

    if (!src) {

      return undefined;

    }

    (async () => {

      try {

        const response = await djangoApi.get(src, {

          responseType: "blob",

        });

        if (!active) {

          return;

        }

        localUrl = URL.createObjectURL(response.data);

        setObjectUrl(localUrl);

      } catch (error) {
  console.error("PROCTOR VIDEO PLAYBACK FAILED:", {
    message: error.message,
    status: error.response?.status,
    response: error.response?.data,
    url: error.config?.url,
  });

  if (active) {
    setVideoError(
      error.response?.data?.detail ||
      `Video playback failed. HTTP ${error.response?.status || "Network Error"}`
    );
  }
}

    })();

    return () => {

      active = false;

      if (localUrl) {

        URL.revokeObjectURL(localUrl);

      }

    };

  }, [src]);

  if (videoError) {

    return (

      <div className="adm-empty-inline">

        {videoError}

      </div>

    );

  }

  return (

    <video

      controls

      playsInline

      preload="metadata"

      style={style}

      src={objectUrl || undefined}

    />

  );

}

function fmtTime(iso) {

  if (!iso) {

    return "—";

  }

  const date = new Date(iso);

  if (Number.isNaN(date.getTime())) {

    return "—";

  }

  return date.toLocaleString();

}

function normalizeStatus(status) {

  return String(status || "")

    .trim()

    .toUpperCase();

}

function statusLabel(status) {

  const value = normalizeStatus(status);

  if (value === "ACTIVE") {

    return "Active";

  }

  if (value === "ENDED") {

    return "Ended";

  }

  return value || "Unknown";

}

function violationSeverity(count) {

  if (count <= 0) {

    return "none";

  }

  if (count <= 2) {

    return "low";

  }

  return "high";

}

function getStudentName(session) {

  return (

    session?.student_name ||

    session?.studentName ||

    session?.student?.full_name ||

    session?.student?.fullName ||

    session?.student?.name ||

    "Unknown student"

  );

}

function getStudentEmail(session) {

  return (

    session?.student_email ||

    session?.studentEmail ||

    session?.student?.email ||

    ""

  );

}

function getExamName(session) {

  return (

    session?.exam_name ||

    session?.examName ||

    session?.exam?.name ||

    "—"

  );

}

function getAttemptId(session) {

  return (

    session?.attempt_id ??

    session?.attemptId ??

    session?.attempt?.id ??

    session?.attempt ??

    "—"

  );

}

function getEvents(session) {

  return Array.isArray(session?.events)

    ? session.events

    : [];

}

function getVideos(session) {

  return Array.isArray(session?.videos)

    ? session.videos

    : [];

}

/*

 * IMPORTANT:

 *

 * Only WARNING and CRITICAL events count as violations.

 *

 * INFO events such as CAMERA_STARTED are NOT violations.

 *

 * If the backend provides a violation_count and there

 * are no event details available, we use that value as

 * a fallback.

 */

function getViolationCount(session) {

  const events = getEvents(session);

  if (events.length > 0) {

    return events.filter((event) => {

      const severity = normalizeSeverity(

        event?.severity

      );

      return (

        severity === "WARNING" ||

        severity === "CRITICAL"

      );

    }).length;

  }

  if (

    typeof session?.violation_count ===

    "number"

  ) {

    return session.violation_count;

  }

  return 0;

}

export default function Proctoring() {

  const [sessions, setSessions] = useState([]);

  const [studentCount, setStudentCount] =

    useState(null);

  const [loadingRoster, setLoadingRoster] =

    useState(true);

  const [loadingDetail, setLoadingDetail] =

    useState(false);

  const [selectedSessionId, setSelectedSessionId] =

    useState(null);

  const [selectedSession, setSelectedSession] =

    useState(null);

  const [error, setError] =

    useState("");

  const [actionMessage, setActionMessage] =

    useState("");

  const [actionError, setActionError] =

    useState("");

  const [warningText, setWarningText] =

    useState(

      "Please remain visible in front of the camera and follow the examination rules."

    );

  const [sendingWarning, setSendingWarning] =

    useState(false);

  const [forceSubmitting, setForceSubmitting] =

    useState(false);

  /*

   * ---------------------------------------------------------

   * Load all proctoring sessions

   * ---------------------------------------------------------

   */

  const loadSessions = async (

    cancelled = false

  ) => {

    try {

      const { data } =

        await getProctorSessions();

      if (cancelled) {

        return;

      }

      const rows = Array.isArray(data)

        ? data

        : [];

      rows.sort((a, b) => {

        const aTime =

          new Date(

            a.started_at ||

              a.startedAt ||

              0

          ).getTime();

        const bTime =

          new Date(

            b.started_at ||

              b.startedAt ||

              0

          ).getTime();

        return bTime - aTime;

      });

      setSessions(rows);

      if (

        selectedSessionId != null

      ) {

        const current = rows.find(

          (row) =>

            String(row.id) ===

            String(selectedSessionId)

        );

        if (current) {

          setSelectedSession(current);

        }

      }

    } catch (err) {

      if (!cancelled) {

        setError(

          err?.response?.data?.detail ||

            "Could not load proctoring sessions."

        );

      }

    } finally {

      if (!cancelled) {

        setLoadingRoster(false);

      }

    }

  };

  /*

   * ---------------------------------------------------------

   * Initial load + polling

   * ---------------------------------------------------------

   */

  useEffect(() => {

    let cancelled = false;

    async function initialLoad() {

      await loadSessions(cancelled);

      try {

        const { data } =

          await getStudents();

        if (!cancelled) {

          setStudentCount(

            Array.isArray(data)

              ? data.length

              : 0

          );

        }

      } catch {

        /*

         * Student count is only used for the

         * dashboard total. Proctoring itself

         * does not depend on it.

         */

      }

    }

    initialLoad();

    const interval = setInterval(

      () => loadSessions(cancelled),

      ROSTER_POLL_MS

    );

    return () => {

      cancelled = true;

      clearInterval(interval);

    };

  }, [selectedSessionId]);

  /*

   * ---------------------------------------------------------

   * Select session

   * ---------------------------------------------------------

   */

  useEffect(() => {

    if (!selectedSessionId) {

      setSelectedSession(null);

      return;

    }

    const existing = sessions.find(

      (session) =>

        String(session.id) ===

        String(selectedSessionId)

    );

    if (existing) {

      setSelectedSession(existing);

    }

  }, [

    selectedSessionId,

    sessions,

  ]);

  /*

   * ---------------------------------------------------------

   * Counts

   * ---------------------------------------------------------

   */

  const counts = useMemo(() => {

    const activeSessions =

      sessions.filter(

        (session) =>

          normalizeStatus(

            session.status

          ) === "ACTIVE"

      );

    const endedSessions =

      sessions.filter(

        (session) =>

          normalizeStatus(

            session.status

          ) === "ENDED"

      );

    const activeStudentIds =

      new Set(

        activeSessions

          .map(

            (session) =>

              session.student_id ??

              session.studentId

          )

          .filter(Boolean)

      );

    const endedStudentIds =

      new Set(

        endedSessions

          .map(

            (session) =>

              session.student_id ??

              session.studentId

          )

          .filter(Boolean)

      );

    const active =

      activeStudentIds.size ||

      activeSessions.length;

    const finished =

      endedStudentIds.size ||

      endedSessions.length;

    const enrolled =

      studentCount != null

        ? studentCount

        : active + finished;

    /*

     * This is only an approximate count when

     * student records are unavailable.

     */

    const startedIds = new Set(

      sessions

        .map(

          (session) =>

            session.student_id ??

            session.studentId

        )

        .filter(Boolean)

    );

    const notStarted =

      studentCount != null

        ? Math.max(

            studentCount -

              startedIds.size,

            0

          )

        : 0;

    return {

      active,

      finished,

      notStarted,

      total: enrolled,

    };

  }, [

    sessions,

    studentCount,

  ]);

  /*

   * ---------------------------------------------------------

   * Roster

   *

   * One row per student, using the latest

   * proctoring session for that student.

   * ---------------------------------------------------------

   */

  const roster = useMemo(() => {

    const map = new Map();

    for (const session of sessions) {

      const studentId =

        session.student_id ??

        session.studentId ??

        `session-${session.id}`;

      if (!map.has(String(studentId))) {

        map.set(

          String(studentId),

          session

        );

      }

    }

    return Array.from(

      map.values()

    );

  }, [sessions]);

  /*

   * ---------------------------------------------------------

   * Selected information

   * ---------------------------------------------------------

   */

  const selectedEvents =

    selectedSession

      ? getEvents(selectedSession)

      : [];

  const selectedVideos =

    selectedSession

      ? getVideos(selectedSession)

      : [];

  const selectedViolationCount =

    selectedSession

      ? getViolationCount(

          selectedSession

        )

      : 0;

  /*

   * ---------------------------------------------------------

   * Event breakdown

   * ---------------------------------------------------------

   */

  const eventTypeCounts =

    useMemo(() => {

      const counts = {};

      for (

        const event of selectedEvents

      ) {

        const type =

          event.event_type ||

          event.eventType ||

          "OTHER";

        counts[type] =

          (counts[type] || 0) + 1;

      }

      return counts;

    }, [selectedEvents]);

  /*

   * ---------------------------------------------------------

   * Severity breakdown

   * ---------------------------------------------------------

   */

  const severityCounts =

    useMemo(() => {

      const counts = {

        INFO: 0,

        WARNING: 0,

        CRITICAL: 0,

      };

      for (

        const event of selectedEvents

      ) {

        const severity =

          normalizeSeverity(

            event?.severity

          );

        if (

          Object.prototype.hasOwnProperty.call(

            counts,

            severity

          )

        ) {

          counts[severity] += 1;

        } else {

          counts.INFO += 1;

        }

      }

      return counts;

    }, [selectedEvents]);

  /*

   * ---------------------------------------------------------

   * Warning

   * ---------------------------------------------------------

   */

  const handleWarning = async () => {

    if (!selectedSession) {

      return;

    }

    if (

      normalizeStatus(

        selectedSession.status

      ) !== "ACTIVE"

    ) {

      setActionError(

        "A warning can only be sent to an active examination session."

      );

      return;

    }

    const detail =

      warningText.trim();

    if (!detail) {

      setActionError(

        "Please enter a warning message."

      );

      return;

    }

    setSendingWarning(true);

    setActionMessage("");

    setActionError("");

    try {

      await sendProctorWarning(

        selectedSession.id,

        detail

      );

      setActionMessage(

        "Warning recorded successfully."

      );

      /*

       * Reload immediately so the new

       * warning event appears in the log.

       */

      await loadSessions(false);

    } catch (err) {

      setActionError(

        err?.response?.data?.detail ||

          "Could not send the warning."

      );

    } finally {

      setSendingWarning(false);

    }

  };

  /*

   * ---------------------------------------------------------

   * Force submit

   * ---------------------------------------------------------

   */

  const handleForceSubmit = async () => {

    if (!selectedSession) {

      return;

    }

    if (

      normalizeStatus(

        selectedSession.status

      ) !== "ACTIVE"

    ) {

      setActionError(

        "This examination is no longer in progress."

      );

      return;

    }

    const confirmed =

      window.confirm(

        `Force submit the examination for ${getStudentName(

          selectedSession

        )}?\n\nThis will submit and grade the attempt automatically.`

      );

    if (!confirmed) {

      return;

    }

    setForceSubmitting(true);

    setActionMessage("");

    setActionError("");

    try {

      await forceSubmitProctoringAttempt(

        selectedSession.id

      );

      setActionMessage(

        "Examination force-submitted successfully."

      );

      /*

       * Reload the session so the UI

       * immediately changes to ENDED.

       */

      await loadSessions(false);

    } catch (err) {

      setActionError(

        err?.response?.data?.detail ||

          err?.response?.data?.error ||

          "Could not force-submit the examination."

      );

    } finally {

      setForceSubmitting(false);

    }

  };

  return (

    <div className="adm-shell">

      <AdminSidebar />

      <main className="adm-main">

        <AdminTopbar />

        <div className="adm-page-head">

          <div>

            <h1 className="adm-page-title">

              Proctoring

            </h1>

            <p className="adm-page-sub">

              Monitor examination sessions,

              review violations and manage

              proctoring evidence.

            </p>

          </div>

          <div className="adm-retention-note">

            <i className="bi bi-shield-lock" />

            Recorded video kept{" "}

            {RETENTION_DAYS} days,

            then discarded automatically

          </div>

        </div>

        {error && (

          <div

            className="alert alert-danger"

            style={{

              marginBottom: "1rem",

            }}

          >

            {error}

          </div>

        )}

        <div className="adm-status-bar">

          <div className="adm-status-seg">

            <span className="adm-status-icon adm-status-icon-active">

              <i className="bi bi-broadcast" />

            </span>

            <div className="adm-status-seg-text">

              <span className="adm-status-value">

                {counts.active}

              </span>

              <span className="adm-status-label">

                Taking an exam

              </span>

            </div>

            <div className="adm-status-track">

              <div

                className="adm-status-fill adm-status-fill-active"

                style={{

                  width: `${

                    counts.total > 0

                      ? Math.round(

                          (counts.active /

                            counts.total) *

                            100

                        )

                      : 0

                  }%`,

                }}

              />

            </div>

          </div>

          <div className="adm-status-seg">

            <span className="adm-status-icon adm-status-icon-idle">

              <i className="bi bi-hourglass-split" />

            </span>

            <div className="adm-status-seg-text">

              <span className="adm-status-value">

                {counts.notStarted}

              </span>

              <span className="adm-status-label">

                Not started

              </span>

            </div>

            <div className="adm-status-track">

              <div

                className="adm-status-fill adm-status-fill-idle"

                style={{

                  width: `${

                    counts.total > 0

                      ? Math.round(

                          (counts.notStarted /

                            counts.total) *

                            100

                        )

                      : 0

                  }%`,

                }}

              />

            </div>

          </div>

          <div className="adm-status-seg">

            <span className="adm-status-icon adm-status-icon-done">

              <i className="bi bi-check-circle" />

            </span>

            <div className="adm-status-seg-text">

              <span className="adm-status-value">

                {counts.finished}

              </span>

              <span className="adm-status-label">

                Finished

              </span>

            </div>

            <div className="adm-status-track">

              <div

                className="adm-status-fill adm-status-fill-done"

                style={{

                  width: `${

                    counts.total > 0

                      ? Math.round(

                          (counts.finished /

                            counts.total) *

                            100

                        )

                      : 0

                  }%`,

                }}

              />

            </div>

          </div>

          <div className="adm-status-seg adm-status-seg-total">

            <div className="adm-status-seg-text">

              <span className="adm-status-value">

                {counts.total}

              </span>

              <span className="adm-status-label">

                Enrolled total

              </span>

            </div>

          </div>

        </div>

        <div className="adm-proctor-layout">

          {/* =====================================================

              SESSION / STUDENT LIST

          ====================================================== */}

          <div className="adm-card adm-roster">

            <div className="adm-card-header">

              Proctoring Sessions

              <span className="adm-count">

                {roster.length}

              </span>

            </div>

            {loadingRoster ? (

              <div className="adm-empty">

                Loading proctoring sessions…

              </div>

            ) : roster.length === 0 ? (

              <div className="adm-empty">

                No proctoring sessions found.

                Sessions appear here when a

                student starts an exam with

                proctoring enabled.

              </div>

            ) : (

              <div className="adm-roster-scroll">

                <table className="adm-table">

                  <colgroup>

                    <col className="adm-col-student" />

                    <col className="adm-col-status" />

                    <col className="adm-col-started" />

                    <col className="adm-col-violations" />

                  </colgroup>

                  <thead>

                    <tr>

                      <th>

                        Student

                      </th>

                      <th>

                        Status

                      </th>

                      <th>

                        Started

                      </th>

                      <th className="adm-col-num">

                        Violations

                      </th>

                    </tr>

                  </thead>

                  <tbody>

                    {roster.map(

                      (session) => {

                        const violationCount =

                          getViolationCount(

                            session

                          );

                        const selected =

                          String(

                            session.id

                          ) ===

                          String(

                            selectedSessionId

                          );

                        const status =

                          normalizeStatus(

                            session.status

                          );

                        return (

                          <tr

                            key={session.id}

                            className={

                              selected

                                ? "selected"

                                : ""

                            }

                            onClick={() =>

                              setSelectedSessionId(

                                session.id

                              )

                            }

                          >

                            <td>

                              <div className="adm-student-cell">

                                <div

                                  className={`adm-roster-thumb adm-roster-thumb-${status.toLowerCase()}`}

                                >

                                  <div className="adm-roster-thumb-empty">

                                    <i className="bi bi-camera-video" />

                                  </div>

                                </div>

                                <div className="adm-student-text">

                                  <div

                                    className="adm-student-name"

                                    title={getStudentName(

                                      session

                                    )}

                                  >

                                    {getStudentName(

                                      session

                                    )}

                                  </div>

                                  <div

                                    className="adm-student-course"

                                    title={getExamName(

                                      session

                                    )}

                                  >

                                    {getExamName(

                                      session

                                    )}

                                  </div>

                                </div>

                              </div>

                            </td>

                            <td>

                              <span

                                className={`adm-status-badge adm-status-${status.toLowerCase()}`}

                              >

                                {statusLabel(

                                  status

                                )}

                              </span>

                            </td>

                            <td>

                              <span className="adm-started-cell">

                                {timeAgo(

                                  session.started_at ||

                                    session.startedAt

                                )}

                              </span>

                            </td>

                            <td className="adm-col-num">

                              <span

                                className={`adm-violation-badge adm-violation-${violationSeverity(

                                  violationCount

                                )}`}

                              >

                                {violationCount}

                              </span>

                            </td>

                          </tr>

                        );

                      }

                    )}

                  </tbody>

                </table>

              </div>

            )}

          </div>

          {/* =====================================================

              DETAIL PANEL

          ====================================================== */}

          <div className="adm-card adm-detail">

            {!selectedSession ? (

              <div className="adm-empty">

                Select a student/session to

                view proctoring details.

              </div>

            ) : (

              <>

                <div className="adm-detail-header">

                  <div>

                    <div className="adm-detail-name">

                      {getStudentName(

                        selectedSession

                      )}

                    </div>

                    <div className="adm-detail-course">

                      {getStudentEmail(

                        selectedSession

                      )}

                    </div>

                  </div>

                  <span

                    className={`adm-status-badge adm-status-${normalizeStatus(

                      selectedSession.status

                    ).toLowerCase()}`}

                  >

                    {statusLabel(

                      selectedSession.status

                    )}

                  </span>

                </div>

                <div className="adm-detail-body">

                  {/* =================================================

                      SESSION INFORMATION

                  ================================================== */}

                  <div>

                    <div className="adm-info-list">

                      <div className="adm-info-row">

                        <span className="adm-info-label">

                          Student

                        </span>

                        <span className="adm-info-value">

                          {getStudentName(

                            selectedSession

                          )}

                        </span>

                      </div>

                      <div className="adm-info-row">

                        <span className="adm-info-label">

                          Exam

                        </span>

                        <span className="adm-info-value">

                          {getExamName(

                            selectedSession

                          )}

                        </span>

                      </div>

                      <div className="adm-info-row">

                        <span className="adm-info-label">

                          Attempt

                        </span>

                        <span className="adm-info-value">

                          #{getAttemptId(

                            selectedSession

                          )}

                        </span>

                      </div>

                      <div className="adm-info-row">

                        <span className="adm-info-label">

                          Session

                        </span>

                        <span className="adm-info-value">

                          #{selectedSession.id}

                        </span>

                      </div>

                      <div className="adm-info-row">

                        <span className="adm-info-label">

                          Started

                        </span>

                        <span className="adm-info-value">

                          {fmtTime(

                            selectedSession.started_at

                          )}

                        </span>

                      </div>

                      <div className="adm-info-row">

                        <span className="adm-info-label">

                          Ended

                        </span>

                        <span className="adm-info-value">

                          {fmtTime(

                            selectedSession.ended_at

                          )}

                        </span>

                      </div>

                      <div className="adm-info-row">

                        <span className="adm-info-label">

                          Monitor state

                        </span>

                        <span

                          className={`adm-info-value adm-info-pill adm-info-pill-${violationSeverity(

                            selectedViolationCount

                          )}`}

                        >

                          {selectedViolationCount ===

                            0 &&

                            "Normal"}

                          {selectedViolationCount >

                            0 &&

                            selectedViolationCount <=

                              2 &&

                            "Under review"}

                          {selectedViolationCount >

                            2 &&

                            "Flagged"}

                        </span>

                      </div>

                      <div className="adm-info-row">

                        <span className="adm-info-label">

                          Violations

                        </span>

                        <span className="adm-info-value">

                          {selectedViolationCount}

                        </span>

                      </div>

                    </div>

                    {/* =================================================

                        SEVERITY SUMMARY

                    ================================================== */}

                    <div

                      style={{

                        marginTop: "1rem",

                        display: "flex",

                        gap: "0.5rem",

                        flexWrap: "wrap",

                      }}

                    >

                      <span

                        style={{

                          ...severityStyles("INFO"),

                          display: "inline-flex",

                          alignItems: "center",

                          gap: "0.35rem",

                          padding:

                            "0.25rem 0.55rem",

                          borderRadius: "999px",

                          border:

                            "1px solid",

                          fontSize:

                            "0.72rem",

                          fontWeight: 700,

                        }}

                      >

                        INFO:{" "}

                        {severityCounts.INFO}

                      </span>

                      <span

                        style={{

                          ...severityStyles("WARNING"),

                          display: "inline-flex",

                          alignItems: "center",

                          gap: "0.35rem",

                          padding:

                            "0.25rem 0.55rem",

                          borderRadius: "999px",

                          border:

                            "1px solid",

                          fontSize:

                            "0.72rem",

                          fontWeight: 700,

                        }}

                      >

                        WARNING:{" "}

                        {severityCounts.WARNING}

                      </span>

                      <span

                        style={{

                          ...severityStyles("CRITICAL"),

                          display: "inline-flex",

                          alignItems: "center",

                          gap: "0.35rem",

                          padding:

                            "0.25rem 0.55rem",

                          borderRadius: "999px",

                          border:

                            "1px solid",

                          fontSize:

                            "0.72rem",

                          fontWeight: 700,

                        }}

                      >

                        CRITICAL:{" "}

                        {severityCounts.CRITICAL}

                      </span>

                    </div>

                    {/* =================================================

                        ADMIN ACTIONS

                    ================================================== */}

                    <div className="adm-action-row">

                      <button

                        type="button"

                        className="adm-action-btn"

                        disabled={

                          sendingWarning ||

                          normalizeStatus(

                            selectedSession.status

                          ) !== "ACTIVE"

                        }

                        onClick={() => {

                          setActionError("");

                          setActionMessage("");

                          handleWarning();

                        }}

                      >

                        <span className="adm-action-btn-icon">

                          <i className="bi bi-exclamation-triangle" />

                        </span>

                        {sendingWarning

                          ? "Sending…"

                          : "Warning"}

                      </button>

                      <button

                        type="button"

                        className="adm-action-btn"

                        disabled={

                          forceSubmitting ||

                          normalizeStatus(

                            selectedSession.status

                          ) !== "ACTIVE"

                        }

                        onClick={

                          handleForceSubmit

                        }

                      >

                        <span className="adm-action-btn-icon">

                          <i className="bi bi-box-arrow-right" />

                        </span>

                        {forceSubmitting

                          ? "Submitting…"

                          : "Force submit"}

                      </button>

                    </div>

                    {/* Warning message */}

                    {normalizeStatus(

                      selectedSession.status

                    ) === "ACTIVE" && (

                      <div

                        style={{

                          marginTop:

                            "0.9rem",

                        }}

                      >

                        <label

                          style={{

                            display:

                              "block",

                            marginBottom:

                              "0.4rem",

                            fontSize:

                              "0.85rem",

                            fontWeight:

                              600,

                          }}

                        >

                          Warning message

                        </label>

                        <textarea

                          value={

                            warningText

                          }

                          onChange={(e) =>

                            setWarningText(

                              e.target.value

                            )

                          }

                          rows={3}

                          style={{

                            width:

                              "100%",

                            resize:

                              "vertical",

                            border:

                              "1px solid #ddd",

                            borderRadius:

                              "8px",

                            padding:

                              "0.65rem",

                          }}

                        />

                      </div>

                    )}

                    {actionMessage && (

                      <div

                        className="alert alert-success"

                        style={{

                          marginTop:

                            "0.8rem",

                        }}

                      >

                        {actionMessage}

                      </div>

                    )}

                    {actionError && (

                      <div

                        className="alert alert-danger"

                        style={{

                          marginTop:

                            "0.8rem",

                        }}

                      >

                        {actionError}

                      </div>

                    )}

                  </div>

                  {/* =================================================

                      EVENT SUMMARY

                  ================================================== */}

                  <div>

                    <div

                      className="adm-subheader"

                      style={{

                        marginBottom:

                          "0.8rem",

                      }}

                    >

                      Violation summary

                    </div>

                    {Object.keys(

                      eventTypeCounts

                    ).length === 0 ? (

                      <div className="adm-empty-inline">

                        No events recorded.

                      </div>

                    ) : (

                      <div className="adm-stat-strip">

                        {Object.entries(

                          eventTypeCounts

                        ).map(

                          ([

                            type,

                            count,

                          ]) => (

                            <div

                              key={type}

                              className={`adm-stat-chip adm-event-${type}`}

                            >

                              <span className="adm-stat-chip-count">

                                {count}

                              </span>

                              <span className="adm-stat-chip-label">

                                {eventLabel(

                                  type

                                )}

                              </span>

                            </div>

                          )

                        )}

                      </div>

                    )}

                  </div>

                </div>

                {/* ===================================================

                    EVENTS + VIDEOS

                ==================================================== */}

                <div className="adm-detail-columns">

                  {/* Events */}

                  <div>

                    <div className="adm-subheader">

                      Proctoring event log

                      <span className="adm-count">

                        {selectedEvents.length}

                      </span>

                    </div>

                    <ul

                      className="adm-event-list"

                      style={{

                        listStyle:

                          "none",

                        padding: 0,

                        margin: 0,

                      }}

                    >

                      {selectedEvents.length ===

                        0 && (

                        <li className="adm-empty-inline">

                          No proctoring events

                          recorded.

                        </li>

                      )}

                      {selectedEvents

                        .slice()

                        .sort(

                          (a, b) =>

                            new Date(

                              b.occurred_at ||

                                b.occurredAt ||

                                0

                            ) -

                            new Date(

                              a.occurred_at ||

                                a.occurredAt ||

                                0

                            )

                        )

                        .slice(0, 50)

                        .map(

                          (event) => {

                            const type =

                              event.event_type ||

                              event.eventType ||

                              "OTHER";

                            const severity =

                              normalizeSeverity(

                                event.severity

                              );

                            const detail =

                              event.detail ||

                              "No additional details available.";

                            const severityStyle =

                              severityStyles(

                                severity

                              );

                            return (

                              <li

                                key={

                                  event.id

                                }

                                style={eventRowStyles(

                                  severity

                                )}

                              >

                                <div

                                  style={{

                                    display:

                                      "flex",

                                    alignItems:

                                      "flex-start",

                                    gap:

                                      "0.7rem",

                                  }}

                                >

                                  {/* Event dot */}

                                  <span

                                    className={`adm-event-dot adm-event-${type}`}

                                    style={{

                                      flex:

                                        "0 0 auto",

                                      marginTop:

                                        "0.45rem",

                                    }}

                                  />

                                  <div

                                    style={{

                                      flex: 1,

                                      minWidth:

                                        0,

                                    }}

                                  >

                                    {/* Event heading */}

                                    <div

                                      style={{

                                        display:

                                          "flex",

                                        alignItems:

                                          "center",

                                        gap:

                                          "0.55rem",

                                        flexWrap:

                                          "wrap",

                                      }}

                                    >

                                      <span

                                        className="adm-event-type"

                                      >

                                        {eventLabel(

                                          type

                                        )}

                                      </span>

                                      {/* IMPORTANT:

                                          This is the WARNING /

                                          INFO / CRITICAL badge.

                                      */}

                                      <span

                                        style={{

                                          ...severityStyle,

                                          display:

                                            "inline-flex",

                                          alignItems:

                                            "center",

                                          gap:

                                            "0.25rem",

                                          padding:

                                            "0.18rem 0.55rem",

                                          borderRadius:

                                            "999px",

                                          border:

                                            "1px solid",

                                          fontSize:

                                            "0.68rem",

                                          fontWeight:

                                            800,

                                          letterSpacing:

                                            "0.03em",

                                          textTransform:

                                            "uppercase",

                                        }}

                                      >

                                        {severity ===

                                          "CRITICAL" && (

                                          <i className="bi bi-exclamation-octagon-fill" />

                                        )}

                                        {severity ===

                                          "WARNING" && (

                                          <i className="bi bi-exclamation-triangle-fill" />

                                        )}

                                        {severity ===

                                          "INFO" && (

                                          <i className="bi bi-info-circle-fill" />

                                        )}

                                        {severityLabel(

                                          severity

                                        )}

                                      </span>

                                      {/* Time */}

                                      <span

                                        className="adm-event-time"

                                        title={fmtTime(

                                          event.occurred_at ||

                                            event.occurredAt

                                        )}

                                      >

                                        {timeAgo(

                                          event.occurred_at ||

                                            event.occurredAt

                                        )}

                                      </span>

                                    </div>

                                    {/* IMPORTANT:

                                        This displays the backend

                                        warning detail.

                                    */}

                                    <div

                                      style={{

                                        marginTop:

                                          "0.35rem",

                                        fontSize:

                                          "0.82rem",

                                        lineHeight:

                                          1.5,

                                        color:

                                          severity ===

                                          "CRITICAL"

                                            ? "#991b1b"

                                            : severity ===

                                              "WARNING"

                                            ? "#78350f"

                                            : "#475569",

                                        wordBreak:

                                          "break-word",

                                      }}

                                    >

                                      {detail}

                                    </div>

                                    {/* Full timestamp */}

                                    <div

                                      style={{

                                        marginTop:

                                          "0.35rem",

                                        fontSize:

                                          "0.7rem",

                                        color:

                                          "#94a3b8",

                                      }}

                                    >

                                      {fmtTime(

                                        event.occurred_at ||

                                          event.occurredAt

                                      )}

                                    </div>

                                  </div>

                                </div>

                              </li>

                            );

                          }

                        )}

                    </ul>

                  </div>

                  {/* Videos */}

                  <div>

                    <div className="adm-subheader">

                      Recorded videos

                      <span className="adm-count">

                        {selectedVideos.length}

                      </span>

                    </div>

                    {selectedVideos.length ===

                      0 ? (

                      <div className="adm-empty-inline">

                        No recorded videos

                        available for this

                        session.

                      </div>

                    ) : (

                      <div

                        style={{

                          display:

                            "flex",

                          flexDirection:

                            "column",

                          gap:

                            "1rem",

                        }}

                      >

                        {selectedVideos.map(

                          (video) => (

                            <div

                              key={

                                video.id

                              }

                              style={{

                                border:

                                  "1px solid #e5e7eb",

                                borderRadius:

                                  "10px",

                                padding:

                                  "0.75rem",

                              }}

                            >

                              <div

                                style={{

                                  marginBottom:

                                    "0.6rem",

                                  fontSize:

                                    "0.82rem",

                                  display:

                                    "flex",

                                  justifyContent:

                                    "space-between",

                                  gap:

                                    "1rem",

                                  flexWrap:

                                    "wrap",

                                }}

                              >

                                <span>

                                  Uploaded:{" "}

                                  {fmtTime(

                                    video.uploaded_at

                                  )}

                                </span>

                                <span>

                                  Expires:{" "}

                                  {fmtTime(

                                    video.expires_at

                                  )}

                                </span>

                              </div>

                              {video.deleted_at ? (

                                <div className="adm-empty-inline">

                                  This video has

                                  expired and was

                                  deleted.

                                </div>

                              ) : getRecordedVideoPlaybackUrl(video, selectedSession) ? (

                                <AuthenticatedVideo

                                  src={getRecordedVideoPlaybackUrl(

                                    video,

                                    selectedSession

                                  )}

                                  style={{

                                    width: "100%",

                                    maxHeight: "320px",

                                    borderRadius: "8px",

                                    background: "#000",

                                  }}

                                />

                              ) : (

                                <div className="adm-empty-inline">

                                  Video file is

                                  unavailable.

                                </div>

                              )}

                            </div>

                          )

                        )}

                      </div>

                    )}

                  </div>

                </div>

              </>

            )}

          </div>

        </div>

      </main>

    </div>

  );

}
